/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tld_Pricing_Status_WithdrawnInputs */

const id_tld_pricing_status_withdrawn = /** @type {(inputs: Tld_Pricing_Status_WithdrawnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nonaktif`)
};

const en_tld_pricing_status_withdrawn = /** @type {(inputs: Tld_Pricing_Status_WithdrawnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Withdrawn`)
};

/**
* | output |
* | --- |
* | "Withdrawn" |
*
* @param {Tld_Pricing_Status_WithdrawnInputs} inputs
* @param {{ locale?: "id" | "en" }} options
* @returns {LocalizedString}
*/
export const tld_pricing_status_withdrawn = /** @type {((inputs?: Tld_Pricing_Status_WithdrawnInputs, options?: { locale?: "id" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tld_Pricing_Status_WithdrawnInputs, { locale?: "id" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tld_pricing_status_withdrawn(inputs)
	return id_tld_pricing_status_withdrawn(inputs)
});